/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Process_Step_Statement_ExtractionInputs */

const en_input_process_step_statement_extraction = /** @type {(inputs: Input_Process_Step_Statement_ExtractionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statement extraction`)
};

const nl_input_process_step_statement_extraction = /** @type {(inputs: Input_Process_Step_Statement_ExtractionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extractie financiële overzichten`)
};

/**
* | output |
* | --- |
* | "Statement extraction" |
*
* @param {Input_Process_Step_Statement_ExtractionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const input_process_step_statement_extraction = /** @type {((inputs?: Input_Process_Step_Statement_ExtractionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Process_Step_Statement_ExtractionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_input_process_step_statement_extraction(inputs)
	return en_input_process_step_statement_extraction(inputs)
});